<template>
  <el-row justify="center">
    <el-col :xs="24" :sm="22" :md="20">

      <div class="page-header">
        <h2 class="h4 mb-0">管理后台 - 审批中心</h2>
      </div>

      <el-tabs type="border-card" v-model="activeTab" @tab-change="handleTabChange">

        <el-tab-pane label="积分审批" name="points">
          <el-alert
            v-if="pointErrorMessage"
            :title="pointErrorMessage"
            type="error"
            show-icon
            class="mb-3"
            :closable="false"
          />
          <el-table :data="pointApplications" v-loading="isPointLoading" stripe>
            <el-table-column prop="applicant" label="申请人" width="120" />
            <el-table-column prop="rule" label="申请规则" min-width="200" />
            <el-table-column prop="details" label="详情" min-width="200" />
            <el-table-column label="提交日期" width="120">
              <template #default="scope">
                {{ new Date(scope.row.submission_date).toLocaleDateString() }}
              </template>
            </el-table-column>
            <el-table-column label="证明" width="100" align="center">
              <template #default="scope">
                <el-link v-if="scope.row.proof" :href="scope.row.proof" type="primary" target="_blank">
                  查看
                </el-link>
                <span v-else class="text-muted">无</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center" fixed="right">
              <template #default="scope">
                <el-button
                  type="success"
                  size="small"
                  :loading="scope.row.isProcessing === 'approve'"
                  @click="handleApprovePoint(scope.row.id)">
                  批准
                </el-button>
                <el-button
                  type="danger"
                  size="small"
                  :loading="scope.row.isProcessing === 'reject'"
                  @click="handleRejectPoint(scope.row.id)">
                  拒绝
                </el-button>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty description="没有待审批的积分申请。" />
            </template>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="资源审批" name="resources">
          <el-alert
            v-if="resourceErrorMessage"
            :title="resourceErrorMessage"
            type="error"
            show-icon
            class="mb-3"
            :closable="false"
          />
          <el-table :data="pendingResources" v-loading="isResourceLoading" stripe>
            <el-table-column prop="uploader" label="上传者" width="120" />
            <el-table-column prop="title" label="资源标题" min-width="200" />
            <el-table-column label="上传日期" width="120">
              <template #default="scope">
                {{ new Date(scope.row.upload_date).toLocaleDateString() }}
              </template>
            </el-table-column>
            <el-table-column label="预览" width="100" align="center">
              <template #default="scope">
                <el-link :href="scope.row.file_url" type="primary" target="_blank">
                  点击查看
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center" fixed="right">
              <template #default="scope">
                <el-button
                  type="success"
                  size="small"
                  :loading="scope.row.isProcessing === 'approve'"
                  @click="handleApproveResource(scope.row.id)">
                  批准
                </el-button>
                <el-button
                  type="danger"
                  size="small"
                  :loading="scope.row.isProcessing === 'reject'"
                  @click="handleRejectResource(scope.row.id)">
                  拒绝 (删除)
                </el-button>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty description="没有待审批的资源。" />
            </template>
          </el-table>
        </el-tab-pane>

        </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios';
import { ElMessageBox, ElMessage } from 'element-plus';

export default {
  name: 'AdminDashboardView',
  data() {
    return {
      activeTab: 'points', // 默认显示第一个选项卡

      // 积分审批的状态
      isPointLoading: true,
      pointApplications: [],
      pointErrorMessage: null,

      // 【!! 重构 !!】: 资源审批的状态
      isResourceLoading: false, // 默认不加载
      pendingResources: [],
      resourceErrorMessage: null,
      hasResourcesLoaded: false, // 防止重复加载
    };
  },

  async mounted() {
    // 【!! 重构 !!】: 只加载默认的第一个选项卡
    this.fetchPendingPoints();
  },

  methods: {
    // 【!! 重构 !!】: 懒加载选项卡
    handleTabChange(tabName) {
      if (tabName === 'resources' && !this.hasResourcesLoaded) {
        this.fetchPendingResources();
        this.hasResourcesLoaded = true; // 标记为已加载
      }
    },

    // --- 1. 积分审批 (逻辑不变) ---
    async fetchPendingPoints() {
      this.isPointLoading = true;
      this.pointErrorMessage = null;
      const token = localStorage.getItem('authToken');

      try {
        const response = await axios.get('/members/api/admin/pending_applications/', {
          headers: { 'Authorization': `Token ${token}` }
        });
        this.pointApplications = response.data.map(app => ({ ...app, isProcessing: null }));
      } catch (error) {
        console.error('获取待审批积分失败:', error);
        if (error.response && error.response.status === 403) {
          this.pointErrorMessage = '您没有权限访问此页面。';
        } else {
          // (这个就是您看到的错误)
          this.pointErrorMessage = '加载数据失败，请稍后再试。';
        }
      } finally {
        this.isPointLoading = false;
      }
    },
    async handleApprovePoint(appId) {
      const app = this.pointApplications.find(a => a.id === appId);
      if (!app) return;
      app.isProcessing = 'approve';
      const token = localStorage.getItem('authToken');
      try {
        await axios.post(`/members/api/admin/applications/${appId}/approve/`, {}, {
          headers: { 'Authorization': `Token ${token}` }
        });
        this.pointApplications = this.pointApplications.filter(a => a.id !== appId);
        ElMessage({ type: 'success', message: '申请已批准！' });
      } catch (error) {
        ElMessage({ type: 'error', message: '操作失败，请重试。' });
        app.isProcessing = null;
      }
    },
    async handleRejectPoint(appId) {
      const app = this.pointApplications.find(a => a.id === appId);
      if (!app) return;
      try {
        const { value: reason } = await ElMessageBox.prompt(
          '请输入拒绝理由（可选）：', '确认拒绝',
          {
            confirmButtonText: '确认拒绝',
            cancelButtonText: '取消',
            inputValue: '管理员未提供具体理由。',
            type: 'warning',
          }
        );
        app.isProcessing = 'reject';
        const token = localStorage.getItem('authToken');
        try {
          await axios.post(`/members/api/admin/applications/${appId}/reject/`,
            { reason: reason || '管理员未提供具体理由。' },
            { headers: { 'Authorization': `Token ${token}` }
          });
          this.pointApplications = this.pointApplications.filter(a => a.id !== appId);
          ElMessage({ type: 'info', message: '申请已拒绝。' });
        } catch (error) {
          ElMessage({ type: 'error', message: '操作失败，请重试。' });
          app.isProcessing = null;
        }
      } catch (action) {
        if (action === 'cancel') {
          ElMessage({ type: 'info', message: '操作已取消。' });
        }
      }
    },

    // --- 2. 资源审批 (逻辑不变) ---
    async fetchPendingResources() {
      this.isResourceLoading = true;
      this.resourceErrorMessage = null;
      const token = localStorage.getItem('authToken');
      try {
        const response = await axios.get('/members/api/admin/pending_resources/', {
          headers: { 'Authorization': `Token ${token}` }
        });
        this.pendingResources = response.data.map(res => ({ ...res, isProcessing: null }));
      } catch (error) {
        console.error('获取待审批资源失败:', error);
        if (error.response && error.response.status === 403) {
          this.resourceErrorMessage = '您没有权限访问此页面。';
        } else {
          this.resourceErrorMessage = '加载待审批资源失败。';
        }
      } finally {
        this.isResourceLoading = false;
      }
    },
    async handleApproveResource(resId) {
      const res = this.pendingResources.find(r => r.id === resId);
      if (!res) return;
      res.isProcessing = 'approve';
      const token = localStorage.getItem('authToken');
      try {
        await axios.post(`/members/api/admin/resources/${resId}/approve/`, {}, {
          headers: { 'Authorization': `Token ${token}` }
        });
        this.pendingResources = this.pendingResources.filter(r => r.id !== resId);
        ElMessage({ type: 'success', message: '资源已批准！' });
      } catch (error) {
        ElMessage({ type: 'error', message: '操作失败，请重试。' });
        res.isProcessing = null;
      }
    },
    async handleRejectResource(resId) {
      const res = this.pendingResources.find(r => r.id === resId);
      if (!res) return;
      try {
        await ElMessageBox.confirm(
          `您确定要【永久删除】这个资源吗？ (${res.title})`,
          '危险操作确认',
          {
            confirmButtonText: '确认删除',
            cancelButtonText: '取消',
            type: 'warning',
          }
        );
        res.isProcessing = 'reject';
        const token = localStorage.getItem('authToken');
        try {
          await axios.post(`/members/api/admin/resources/${resId}/reject/`, {}, {
            headers: { 'Authorization': `Token ${token}` }
          });
          this.pendingResources = this.pendingResources.filter(r => r.id !== resId);
          ElMessage({ type: 'info', message: '资源已删除。' });
        } catch (error) {
          ElMessage({ type: 'error', message: '删除失败，请重试。' });
          res.isProcessing = null;
        }
      } catch (action) {
        if (action === 'cancel') {
          ElMessage({ type: 'info', message: '操作已取消。' });
        }
      }
    }
  }
};
</script>

<style scoped>
/* (样式保持不变) */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.page-header .h4 {
  font-weight: 600;
}
.mb-0 {
  margin-bottom: 0;
}
.mb-3 {
  margin-bottom: 1.25rem;
}
.text-muted {
  color: var(--el-text-color-secondary);
  font-size: 0.9rem;
}
</style>